const OTA_LOGO_MAP: Record<string, string> = {
    BookingCom: '/ota/bookingcom.png',
    Agoda: '/ota/agoda_mainlogo_stack_positive_ai_Main Logo.png',
    AirBNB: '/ota/airbnb.png',
    CTrip: '/ota/ctrip-logo-png_seeklogo-341264.png',
    Traveloka: '/ota/idgaNgeFw0_1744878763757.png',
    TiketCom: '/ota/ac13e03e-896c-4bbb-ba7c-cdf9b04a68b7-1709290197088-cb26aa8c25b24b1aa5df8bb2edce7ea7.webp',
    Expedia: '/ota/BEX_Logo_Horizontal_CMYK_FullColorDarkBlue--1024x199.jpg',
    MGBedbank: '/icons/MgBedbankLogo.webp',
    Hostelworld: '/ota/hw-horizontal-orange-rgb.png',
    Alaric: '/ota/alaric.png',
    OpenShopping: '/ota/OpenShopping.png',
    Goibibo: '/ota/goibibo.png',
    Bedshero: '/ota/bedshero_logo.png'
};

export default OTA_LOGO_MAP;